import React from 'react';
import { compose } from 'redux';
import { MediaSourceType } from '../../types';
import { setGallectionCover } from '../../actions';
import MediaSelector from '../../MediaSelector';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { DeviationTypes } from '../../../types/deviation';
var enhance = compose(connectMediaStore(null, {
    setGallectionCover: setGallectionCover,
}));
export var GallectionCoverSelector = function (_a) {
    var gallection = _a.gallection, setGallectionCoverAction = _a.setGallectionCover, onClose = _a.onClose;
    return (React.createElement(MediaSelector, { mediaSourceTypes: [MediaSourceType.GALLERY, MediaSourceType.STASH], allowGifs: false, allowedDeviationTypes: [DeviationTypes.IMAGE, DeviationTypes.LITERATURE], onClose: onClose, onSelect: function (selectedDeviations) {
            setGallectionCoverAction({
                gallection: gallection,
                deviation: selectedDeviations[0],
            });
            onClose();
        } }));
};
GallectionCoverSelector.displayName = 'GallectionCoverSelector';
export default enhance(GallectionCoverSelector);
//# sourceMappingURL=GallectionCoverSelector.connected.js.map